import React from 'react';
import { Form, Input } from 'antd';
const FormItem = Form.Item;
const requiredFieldRules = {
  required: true,
  message: 'Поле, обязательно для заполнения',
};
class ProfileForm extends React.Component {
  onChange = e => {
    let { formData } = this.props;
    const { formChange } = this.props;
    const target = e.target;
    const value = target.value;
    const name = target.name;
    formData.company = { ...formData.company, [name]: value };
    formChange(formData);
  };

  render() {
    const { formData, form } = this.props;
    const formState = formData.company;
    const { getFieldDecorator } = form;
    return (
      <React.Fragment>
        <div className="personalDataGroup">
          <FormItem label="Название организации" className="lastName">
            {getFieldDecorator('name_legal', {
              rules: [requiredFieldRules],
              initialValue: formState.name_legal,
            })(
              <Input
                name="name_legal"
                placeholder="Укажите название организации"
                onChange={this.onChange}
              />
            )}
          </FormItem>
          <FormItem label="Юридический адрес">
            {getFieldDecorator('address_legal', {
              rules: [requiredFieldRules],
              initialValue: formState.address_legal,
            })(
              <Input
                name="address_legal"
                onChange={this.onChange}
                placeholder="Укажите юридический адрес"
              />
            )}
          </FormItem>
          <FormItem label="ОГРН">
            {getFieldDecorator('ogrn', {
              rules: [requiredFieldRules],
              initialValue: formState.ogrn,
            })(
              <Input
                name="ogrn"
                onChange={this.onChange}
                placeholder="Укажите ОГРН"
              />
            )}
          </FormItem>
          {/*<FormItem label="ИНН">*/}
          {/*    /!*{getFieldDecorator('inn', {*!/*/}
          {/*    /!*    initialValue: formState.inn*!/*/}
          {/*    /!*})(*!/*/}
          {/*        <Input*/}
          {/*            value={inn}*/}
          {/*            name='inn'*/}
          {/*            onChange={this.onChange}*/}
          {/*            placeholder="Укажите ИНН"*/}
          {/*        />*/}
          {/*    /!*)}*!/*/}
          {/*</FormItem>*/}
          <FormItem label="КПП">
            {getFieldDecorator('kpp', {
              rules: [requiredFieldRules],
              initialValue: formState.kpp,
            })(
              <Input
                name="kpp"
                onChange={this.onChange}
                placeholder="Укажите КПП"
              />
            )}
          </FormItem>
          <FormItem label="Сайт">
            {getFieldDecorator('site', {
              rules: [requiredFieldRules],
              initialValue: formState.site,
            })(
              <Input
                name="site"
                onChange={this.onChange}
                placeholder="Укажите сайт"
              />
            )}
          </FormItem>
          <FormItem label="Паспортные данные">
            {getFieldDecorator('passport_data', {
              rules: [requiredFieldRules],
              initialValue: formState.passport_data,
            })(
              <Input
                name="passport_data"
                onChange={this.onChange}
                placeholder="Укажите паспортные данные"
              />
            )}
          </FormItem>
          <FormItem label="Паспортный орган">
            {getFieldDecorator('passport_authority', {
              rules: [requiredFieldRules],
              initialValue: formState.passport_authority,
            })(
              <Input
                name="passport_authority"
                onChange={this.onChange}
                placeholder="Укажите паспортный орган"
              />
            )}
          </FormItem>
          <FormItem label="Фактический адрес">
            {getFieldDecorator('address_fact', {
              rules: [requiredFieldRules],
              initialValue: formState.address_fact,
            })(
              <Input
                name="address_fact"
                onChange={this.onChange}
                placeholder="Укажите фактический адрес"
              />
            )}
          </FormItem>
        </div>
      </React.Fragment>
    );
  }
}

export default ProfileForm;
